export default class CategorizationFlows {
  static RULE = "rule";

  static REASON = "reason";

  static DESCRIPTION = "description";

  static VENDOR = "vendor";

  static AI = "ai";
}
